import backIcon from "./../../images/new/meme/back.svg";

const BackButton = ({onClick}) => {
  return (
    <button className="customButton secondaryButton backButton" onClick={onClick}>
      <img src={backIcon} alt="Back" />
      Go Back
    </button>
  );
};

export default BackButton;
